import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vaccine-table" }
const _hoisted_2 = { class: "full-row big" }
const _hoisted_3 = {
  key: 0,
  class: "red big"
}
const _hoisted_4 = {
  key: 1,
  class: "green big"
}
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = {
  key: 3,
  class: "expiration"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = {
  key: 1,
  class: "expiration"
}
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["dog-creator", {standalone: !$props.inline}]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("header", null, [
      _createElementVNode("span", null, _toDisplayString($setup.dogDetails.name) + "'s", 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", null, " Vaccination Records", -1))
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Dogspaces.Schema.shape.vaccines.unwrap().shape, (prop, key) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(prop.description), 1),
          ($setup.dogDetails.vaccines?.[key])
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([$setup.dogDetails.vaccines[key]!], (vax) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  ($setup.vaxExpired(vax))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Expired"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, "Valid")),
                  ($setup.vaxFiles[key])
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 2,
                        class: "expiration",
                        type: "date",
                        "onUpdate:modelValue": ($event: any) => (($setup.vaxExp[key]) = $event)
                      }, null, 8, _hoisted_5)), [
                        [_vModelText, $setup.vaxExp[key]]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(new Date(vax.expires).toLocaleDateString('default', {year: '2-digit', month: '2-digit', day: '2-digit'})), 1)),
                  _createVNode(_component_FileUploader, {
                    onFileAdded: ($event: any) => ($setup.handleVax($event, key)),
                    "file-extensions": ['.png', '.jpg', '.jpeg', '.pdf']
                  }, {
                    default: _withCtx(() => [
                      ($setup.vaxFiles[key])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($setup.vaxFiles[key]?.name), 1))
                        : ($setup.dogDetails.vaccines?.[key])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                              _createVNode($setup["VaccineDownload"], {
                                class: "button",
                                "doc-ref": $setup.dogDetails.vaccines[key]!.ref
                              }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                  _createTextVNode("Download document")
                                ])),
                                _: 2
                              }, 1032, ["doc-ref"])
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["onFileAdded"])
                ], 64))
              }), 256))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[3] || (_cache[3] = _createElementVNode("div", null, "No Vaccine Uploaded", -1)),
                ($setup.vaxFiles[key])
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      class: "expiration",
                      type: "date",
                      "onUpdate:modelValue": ($event: any) => (($setup.vaxExp[key]) = $event)
                    }, null, 8, _hoisted_9)), [
                      [_vModelText, $setup.vaxExp[key]]
                    ])
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, "...")),
                _createVNode(_component_FileUploader, {
                  onFileAdded: ($event: any) => ($setup.handleVax($event, key)),
                  "file-extensions": ['.png', '.jpg', '.jpeg', '.pdf']
                }, {
                  default: _withCtx(() => [
                    ($setup.vaxFiles[key])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.vaxFiles[key]?.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["onFileAdded"])
              ], 64))
        ], 64))
      }), 256))
    ])
  ], 2))
}